// removed by extract-text-webpack-plugin
module.exports = {"wordChart":"newest_wordChart_1_g36"};


//////////////////
// WEBPACK FOOTER
// ./src/components/regulatoryStatistical/index/state/newest.scss
// module id = 1569
// module chunks = 0